module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2r"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "pt01ch01"
    }
  }, [_vm._v("chapter one")])]), _c('a', {
    attrs: {
      "id": "pt01ch01"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“So”—Janet glanced down at my résumé—“Felicity. You’d like to be a matchmaker. Can you go into more detail why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Because my mom threatened bodily harm unless I get off my lazy butt and get a job")]), _vm._v(". No, that wouldn’t do. Better to try for the more professional approach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I believe in true love,” I replied. “I think everyone has a match out there—some people just need a little help finding that special person. I think it would be fun to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet smiled, her bright, white teeth sparkling in the soft light pouring from the window. “Good answer. That’s what we believe too. Here at Cupid’s Hollow we want to find true love for everyone.”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pt01ch01"
    }
  }, [_vm._v("I nodded, trying not to fidget with the clicky end of my pen. ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("This was my first real interview, and I was determined not to let my twitchy thumb get the best of me. After applying for a thousand jobs (and getting a thousand rejections), I’d found a tiny ad on the back page of Cleveland’s "), _c('em', [_vm._v("Scene")]), _vm._v(" magazine: teen cupids wanted "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR MATCHMAKING COMPANY. CALL FOR INTERVIEW")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a cute angle to advertise for employees in that way, so I called. Two days later, here I was. In all my nervous, sweaty glory, working it as best as I could so I wouldn’t look or sound like a total idiot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, you’re a junior,” Janet said. “And what school do you go to again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Greenville High. Go, Cougars!” I cheered, then winced internally at my dorkiness. Oh, man, that was way lame. Like she cared about our school mascot. "), _c('em', [_vm._v("I")]), _vm._v(" didn’t even care most of the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um-hm,” she said, her face unreadable. She flipped through the notepad on her lap and scribbled furiously on a page.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crap, did I blow it already? Three minutes into the interview and I’d sunk my own battleship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you’re available to start work …?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As soon as possible,” I spilled out, heart racing. Maybe this could still work out.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("“Have you ever used a BlackBerry or similar handheld technology before?”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, my mom has one, and I’ve used it a little bit.” Okay, that was an exaggeration, as I’ve really only "), _c('em', [_vm._v("seen")]), _vm._v(" her use it, but I’m sure I could figure it out if I needed to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet wrote more notes. “I assume you’ve never participated in or worked for a matchmaking service before?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um, no.” I thought fast. “But I did help my brother set up his Match dot com profile.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My brother is four years older than me and is a cop. Trust me, not a good combination. He’s insane. I can’t count the number of times he’s flashed his stupid badge at me in front of my friends, threatening to haul me in if I mocked his authority again. Total dork.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, last question. This job requires a certain level of … confidentiality.” Janet looked straight into my eyes, her face serious. “Confidentiality for our clients, as well as for our own technologies and processes. You’d have to sign a document promising never to share our information with anyone outside the company. Would that be a problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swallowed. What was I getting myself into here? Was this normal?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('em', [_vm._v("Geez, chill, Felicity.")]), _vm._v(" She wasn’t asking me to sew my lips together and join a convent. They probably just didn’t want other matchmaking companies to steal their ideas or customers.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded and put on my most serious, trustworthy face. “Sure, no problem.” A thought popped into my mind. “Wait, I’m only seventeen. Is the contract legally binding?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shot me a smile. “Good question. It’s binding as far as our concerns go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, then.” Not that I’d be spilling any industry secrets, anyway, so I wouldn’t have to worry about that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet finished writing, then uncrossed her legs and smoothed her prim, plum-colored skirt. She stood and stuck out her hand. “Well, we’d love to have you join our team. Welcome to Cupid’s Hollow, Felicity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bit back my squeal and shook her hand. “This is so awesome. Thank you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She grinned. “Why don’t you come in tomorrow for the training session.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("I thanked her profusely, slipped on my thick winter coat, and left the office, turning back to give the building one last glance. The outside itself was nondescript, just an old brick exterior with lots of ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("windows and a thin layer of late March snow perched on top. But the inside held the key to my working future.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My first real job. I was so excited, I did a little booty shake in the parking lot. I couldn’t wait to tell everyone I knew! If I’d had a cell phone, I could have called my best friends Maya and Andy instead of waiting until I got home. With a job, though, I would now be able to use my own money to buy one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hopped into my mom’s dark green Camry, cranked up the heat and the radio, and headed home, taking the long way through the suburbs instead of driving on Route 480. Mom had let me borrow the car for the interview, but made me swear a solemn oath that I would not go anywhere but to the interview and back, would not pick up any hitchhikers, and would stay off the freeway at all costs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom,” I said as soon as I threw open the front door, “I’m home. I got the job!” On the front porch I stomped the loose snow off my heels, then stepped into the foyer and gingerly slipped out of my boots. After tucking them into the corner of the tiled entryway and hanging my coat in the closet, I added, “And no, I didn’t track snow in the house.” I knew what she was going to ask, because it was the same thing every time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Mom darted out of the kitchen, wearing a white apron over ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("her dress pants. Other than a small smudge of flour on her cheek, she looked pristine and composed, as usual. “Congratulations!” she cried out. “I’m so proud of you.” She leaned over and kissed me on the cheek.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom is surprisingly domestic—she’s as assertive in the kitchen as in her workplace, where she’s in the accounting department. God help any of the company’s clients who are late on their payments, because my mom hounds them until they pay, just to shut her up. She runs our household the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we were younger, my brother and I used to call her the House Nazi. Neither one of us was stupid enough to say it directly to her face, though—I liked my mouth right where it was, thank you very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks, Mom. What’s for dinner?” I asked. “I’m starving to death.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fried chicken, but it’s not ready yet. You should go call Maya and Andy with your good news. They’ll be thrilled.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup, I’m heading up to my room now.” I tossed the keys on the small table in the foyer. “Thanks for letting me borrow the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She winked. “Well, now you can save up and get your own, can’t you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Gee, I’d suspected she’d say that. Now that I had a real job, I could predict the answer for everything:")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Need new clothes, Felicity? Want to go see a movie with your friends? Well, it’s a good thing you’ve got a job now.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I darted up to my room, flung myself across my bed, and grabbed the phone off my nightstand, dialing Andy’s cell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Andy’s mortuary. You stab ’em, we slab ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Andy Carsen is my best friend. She and I have been close since kindergarten. Sometimes, though, I feel a bit jealous of her. Her folks aren’t as harsh as mine can be. And Andy, of course, has a cell phone, just like everybody else I know. I swear, I must be the only teenager in the free world who doesn’t have one. But now that I had a job, that was going to change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, it’s me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So …?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got the job!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She squealed. “That’s awesome! Now you’ll finally have spending money, and we can go shopping more and buy those cute jeans you wanted and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa.” I laughed. “I haven’t even gotten a paycheck yet.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“So, how does this gig work? Will you make those geeky ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("videotapes of people, or is it an online dating thing?”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hm. I hadn’t even bothered to ask. “Actually, I don’t know. I was so excited I got the job, I just took off before she could change her mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re ridiculous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You say that like you’re surprised. Anyway, tomorrow I’ve got training, so I’ll let you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We hung up, and I dialed Maya Takahashi, my other BFF. Maya moved to Cleveland when we were in middle school, and though she’s completely unlike me or Andy in just about every possible way, we clicked. Maybe it was the way she quietly snarked on the preps her first day of school that made me instantly love her. From then on, the three of us have been nearly inseparable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“’Lo,” Maya said into the mouthpiece, her mouth clearly full of food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I answered. “I got the job!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s great. I knew you would.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I heard her chew a few times, so I held the phone away from my ear to let her finish the bite without subjecting me to it. Delicate, she was not, but that was Maya for you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds like you’re busy,” I said. “I’ll let you go.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Sorry, I’m totally stressing over here and trying to multitask by eating and doing homework at the same time. I almost bit off my pen cap! And then, after dinner, I need to practice my solo.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Maya’s a fantastic trumpet player, in addition to all her brain talents. Though I’m not a huge fan of the school band—nerd alert, anyone?—Andy and I do support her and go see all her performances at the school’s basketball games. I know she’d do the same for us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, hope you get it all done. Talk to ya later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("After we hung up, I turned on my PC and logged on to my blog. I made sure to lock it so it was a VIP entry only—Andy, Maya, and I usually shared entries with only each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indentka"
  }, [_vm._v("I’m so excited. Now that I’m a matchmaker, maybe I can even learn some tips to make Derek fall madly in love with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("I sighed. Derek Peterson’s the hottest guy on the face of the earth. Every time I look at him, my heart squeezes up, and I forget how to speak. Not that he ever talks to me, anyway. He’s a smart jock who runs with the AP crowd (shame of all shame, I’m only in honors, not advanced), but we have art class together.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Of course, that’s my favorite class, even though I end up spending the whole time trying not to get busted for staring at him. Or drooling.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I bet half my blog was filled with his name. I’d been crushing on him since the first day of freshman year, when I saw him walking through the hallway at school. Not that he’d noticed me, but it didn’t matter. One look at his beautiful smile, and I was a goner.")]), _vm._v(" "), _c('p', {
    staticClass: "indentk1"
  }, [_vm._v("Derek Peterson-n-Felicity Walker 4-ever")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Mr. and Mrs. Derek Peterson")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Felicity Walker-Peterson")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Felicity Walker-Peterson, M.D.")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Felicity Walker-Peterson, President of the United States")]), _vm._v(" "), _c('p', {
    staticClass: "indentkb"
  }, [_vm._v("Felicity Walker-Peterson, America’s Next Top Model")])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Well, that was fun. I saved and closed the blog, then quickly checked my e-mail (nope, nothing new, except from my spam buddies telling me I won the Irish lotto—lucky me!). Time to start my homework to avoid being grounded for getting anything below a C. ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The next day at the office, Janet handed me a hot-pink PDA. “Here ya go,” she said. “Your LoveLine 3000. Please take care of it. It’s the key to your job.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Whoa. It was possibly the most tricked-out PDA I’d ever seen in my life. There had to be some serious dough coughed up for these puppies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat in the plush green chair across from Janet’s cherry wood desk, flipping on the device and looking at all the buttons. “So, what’s this for? Are we supposed to schedule the customers’ first dates or something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She tilted her head and gave me a funny look. “It has the e-mail addresses of everyone in your territory, which in your case is Greenville High.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait. I’m matchmaking my school?” I didn’t know yet if that was a good or a bad thing, so I tried to keep my voice calm and neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Absolutely. That’s part of the reason we’re hiring. We decided to try a new venture and let people matchmake their own peer groups. After all, who better to be a cupid for a teen than another teen?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“Good point.” Most of my classmates would die laughing if an adult tried to help them find a date. And with good reason. ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("I mean, no disrespect to anyone, but “great personality” can only get you so far in high school.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For instance, look at me. I’ve got personality practically oozing out of my skin, but I’ve only had one boyfriend ever. And he dated me so he could get closer to Andy. I should have picked up the clue phone when he always wanted to do group things—with her tagging along, of course. And here I’d thought he was just getting to know my friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Andy, of course, has no problems getting a guy’s attention. She’s hot, smart, and funny, but she’s also extremely picky, so she doesn’t date a lot. And she’s 100 percent loyal to her friends, so my ex’s strategy to get closer to her backfired, to say the least.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor Maya, on the other hand—the girl’s sharp as a tack, captain of the debate club, lead trumpet in the marching band, but can’t get a date to save her life. In fact, she can’t even get a guy to notice her. Not that she’d even admit to wanting a boyfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And not that she isn’t cute enough, either. It’s just … she’s busy. And kinda shy. But still, I couldn’t exactly picture her signing up with a dating service for help. That just isn’t how it’s done.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Janet delicately cleared her throat. “Felicity, this is no small thing. It’s taken the company thousands of years to evolve and perfect ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("our technology, but I like the way the PDAs work so far.”")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, what did you say?” I must have misheard her. Maybe I needed to pay better attention to this training session instead of thinking about me and my friends’ dating disasters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Trust me,” she continued, chuckling, “you’ll like using this much better than the bows and arrows of yesteryear. The misfiring possibility alone made the job more difficult than it needed to be. And the PDAs are far less cumbersome to carry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swallowed hard. Okay, I hadn’t misunderstood. The lady was obviously a loony-bird.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And I was now employed by her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glanced at the door, trying to think of a polite way to get the hell out of there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet paused, looking at me. “Are we on the same page here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slid my eyes back to her face. “I—I’m guessing not.” Because I was on planet Earth, and Janet was obviously circling somewhere around Jupiter, floating on a pink cloud with rainbows, bunnies, and fluffy kitty cats. And a whole lotta bathtub-created meth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No wonder they always warned us to stay away from drugs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet spoke slowly. “You do understand you’re a cupid now, right?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-584685ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pt01ch01.vue
// module id = 75
// module chunks = 0